import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';

import Button from '../../artzu-ui/src/Button';

import Modal from '../../artzu-ui/src/Modal';
import { ValidatorForm } from 'react-form-validator-core';
import TextInput from './TextInput';
import AutzuLogoLayout from './AutzuLogoLayout';
import { postData } from '../../utils/request';
import './login.css';

class ForgotPass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: window.location.search.slice(7) || '',
      open: false,
      error: false,
    };
  }

  componentWillMount() {
    ValidatorForm.addValidationRule('isEmailInDB', () => !this.state.error);
  }

  openModal = () => {
    this.setState({ open: true });
  };

  closeModal = () => {
    this.setState({ open: false });
  };

  handleChange = ({ target }) => {
    const { name } = target;
    const val = target.value;

    this.setState({ [name]: val, error: false });
  };

  handleSubmit = () => {
    // this.props.tryLogin(this.state, this.props.history);
    postData('reset_request', { user: { ...this.state } })
      .then(() => {
        this.openModal();
      })
      .catch(() => this.setState({ error: true }));
  };

  forgotPass = () => {
    const { email, open } = this.state;
    return (
      <AutzuLogoLayout>
        <ValidatorForm className="forgot-pass__form" instantValidate={false} onSubmit={this.handleSubmit}>
          <div className="forgot-pass__inputs">
            <TextInput
              floatingLabelText="Email"
              onChange={this.handleChange}
              name="email"
              value={email}
              validators={['required', 'isEmail', 'isEmailInDB']}
              errorMessages={['this field is required', 'email is not valid', 'email is not registered']}
            />
          </div>

          {/* <p style={{ color: 'white', marginTop: '2rem' }}>
            New to Autzu?{' '}
            <Link to="/signup" style={{ color: 'white', textDecoration: 'underline' }}>
              Signup
            </Link>
          </p> */}
          <div className="forgot-pass__button">
            <Button size="xl" primary fullWidth type="submit" label="Send password reset" />
            <p className="login__signup">
              <Link to="/login" label="Back to Login">
                Back to Login
              </Link>
            </p>
          </div>
        </ValidatorForm>
        <Modal open={open}>
          <div className="reset__modal">
            <div className="reset__text">An email has been sent with instructions to reset your password.</div>
            <Link to="/login">
              <Button size="xl" primary fullWidth type="submit" label="Back to Log In" />
            </Link>
          </div>
        </Modal>
      </AutzuLogoLayout>
    );
  };

  render() {
    const { loggedIn } = this.props;
    if (loggedIn) {
      return <Redirect to="/dashboard" />;
    }
    return this.forgotPass();
  }
}

export default ForgotPass;



// WEBPACK FOOTER //
// ./src/components/User/ForgotPass.js